// Dependencies
import React, { Component } from 'react';

class HostingInfo extends Component {
  componentDidMount() {
    /* eslint-disable */
    $.HSCore.components.HSModalWindow.init('[data-modal-target]');
  };

  render() {
    const { title, hosting_data } = this.props.data;

    const table = [];
    for (var key in hosting_data) {
      table.push(
        <tr key={key}>
          <td style={{width: '200px'}}>{key}</td>
          <td style={{width: '200px'}}>{hosting_data[key] == 'check' ? <i className="fa fa-check text-success"></i> : hosting_data[key]}</td>
        </tr>
      );
    }

    return (
      
        <div id="hosting-modal" className="text-left g-max-width-600 g-bg-white g-overflow-y-auto g-pa-20" style={{display: 'none'}}>
          <button type="button" className="close" onClick={Custombox.modal.closeAll}>
            <i className="hs-icon hs-icon-close"></i>
          </button>
          <h4 className="g-mb-20">Hosting - Plan {title}</h4>
          <hr/>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody className="table-bordered">
                {table}
              </tbody>
            </table>
          </div>
        </div>

    );
  }
}

export default HostingInfo;


// WEBPACK FOOTER //
// ./src/subcomponents/HostingInfo.js